var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367.81 395.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#91b1fa;}.cls-14,.cls-3{fill:#fff;}.cls-4{opacity:0.19;fill:url(#Degradado_sin_nombre_6);}.cls-5{opacity:0.93;fill:url(#Degradado_sin_nombre_2);}.cls-6{fill:#5c95f3;}.cls-10,.cls-7{fill:#c7c7c7;mix-blend-mode:multiply;}.cls-14,.cls-7{opacity:0.42;}.cls-8{fill:#344b7e;}.cls-9{fill:#2a3f65;}.cls-10{opacity:0.63;}.cls-11{fill:#b2d0f9;}.cls-12{fill:#5085d1;}.cls-13{fill:#f2d279;}.cls-14{mix-blend-mode:lighten;}.cls-15{fill:#e9ad29;}.cls-16{fill:#eed85c;}.cls-17{fill:#f7ec9a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    x1: 189.91,
    y1: 217.62,
    x2: 189.91,
    y2: 395.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 190.24,
    y1: 264.93,
    x2: 190.24,
    y2: 387.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,66.39a2.28,2.28,0,1,1-2.28-2.28A2.28,2.28,0,0,1,302,66.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.92,238.19a2.28,2.28,0,1,1-2.28-2.28A2.28,2.28,0,0,1,325.92,238.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.07,174.75a2.28,2.28,0,1,1-2.28-2.28A2.28,2.28,0,0,1,357.07,174.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.15,
    cy: 243.69,
    r: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.92,12.57a2.28,2.28,0,1,1-2.28-2.28A2.28,2.28,0,0,1,263.92,12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.35,121.73a2.68,2.68,0,1,1-2.68-2.68A2.68,2.68,0,0,1,5.35,121.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.12,148.53l-2-1.06a.68.68,0,0,1-.29-.29l-1.06-2a.72.72,0,0,0-1.26,0l-1.06,2a.81.81,0,0,1-.29.29l-2,1.06a.71.71,0,0,0,0,1.25l2,1.07a.68.68,0,0,1,.29.29l1.06,2a.72.72,0,0,0,1.26,0l1.06-2a.58.58,0,0,1,.29-.29l2-1.07A.71.71,0,0,0,284.12,148.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.18,117.34l-1.75-.93a.65.65,0,0,1-.26-.26l-.94-1.75a.62.62,0,0,0-1.1,0l-.94,1.75a.65.65,0,0,1-.26.26l-1.75.93a.63.63,0,0,0,0,1.11l1.75.94a.65.65,0,0,1,.26.26l.94,1.74a.62.62,0,0,0,1.1,0l.94-1.74a.65.65,0,0,1,.26-.26l1.75-.94A.63.63,0,0,0,105.18,117.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.7,35.31l-3-1.6a1,1,0,0,1-.44-.44l-1.6-3a1.08,1.08,0,0,0-1.89,0l-1.6,3a1,1,0,0,1-.44.44l-3,1.6a1.08,1.08,0,0,0,0,1.89l3,1.6a1,1,0,0,1,.44.44l1.6,3a1.08,1.08,0,0,0,1.89,0l1.6-3a1,1,0,0,1,.44-.44l3-1.6A1.08,1.08,0,0,0,50.7,35.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.11,3.71l-2-1.06a.76.76,0,0,1-.3-.29l-1.06-2a.7.7,0,0,0-1.25,0l-1.06,2a.81.81,0,0,1-.29.29l-2,1.06a.7.7,0,0,0,0,1.25l2,1.06a.76.76,0,0,1,.29.3l1.06,2a.71.71,0,0,0,1.25,0l1.06-2a.72.72,0,0,1,.3-.3l2-1.06A.71.71,0,0,0,150.11,3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.25,91.7l-3-1.6a1,1,0,0,1-.44-.43l-1.6-3a1.07,1.07,0,0,0-1.88,0l-1.59,3a1.07,1.07,0,0,1-.44.43l-3,1.6a1.06,1.06,0,0,0,0,1.88l3,1.6a1.14,1.14,0,0,1,.44.43l1.59,3a1.07,1.07,0,0,0,1.88,0l1.6-3a1.07,1.07,0,0,1,.44-.43l3-1.6A1.07,1.07,0,0,0,367.25,91.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.82,187.32l-3-1.59a1.07,1.07,0,0,1-.43-.44l-1.6-3a1.07,1.07,0,0,0-1.88,0l-1.6,3a1,1,0,0,1-.43.44l-3,1.59a1.08,1.08,0,0,0,0,1.89l3,1.59a1,1,0,0,1,.43.44l1.6,3a1.07,1.07,0,0,0,1.88,0l1.6-3a1.07,1.07,0,0,1,.43-.44l3-1.59A1.08,1.08,0,0,0,64.82,187.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116.96,
    y: 217.62,
    width: 145.91,
    height: 177.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 176.29,
    y: 264.93,
    width: 27.9,
    height: 122.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.83,175.75l34.75,23.71a18.13,18.13,0,0,1,7.92,15v3.17H220.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.63,175.75l-34.75,23.71a18.13,18.13,0,0,0-7.92,15v3.17h42.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.61,181.9l-6.85,4.68s1.6,17.81,7.87,31h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M229.85,181.9l6.85,4.68s-1.6,17.81-7.87,31h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.93,224a2.7,2.7,0,0,0-2.64,3.31l3.05,20.91a2.7,2.7,0,0,0,2.64,2.11h14.76V224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M207.14,248.25l3.06-20.91a2.71,2.71,0,0,0-2.65-3.31H189.74v26.33H204.5A2.7,2.7,0,0,0,207.14,248.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "169.82 231.03 171.29 241.06 208.19 241.06 209.66 231.03 169.82 231.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.63,79.66c-8.41,21.88-14.39,51.25-11.06,88.49,0,0,4.38,40.2,17.91,65.68h24.59V79.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.07,38.15a16.34,16.34,0,0,0-12.78,6.75,152,152,0,0,0-18.66,34.76h31.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.76,79.66H191.07V233.83h22.38S229,212.33,232.16,165C234,137.67,231.8,106.51,222.76,79.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.76,79.66c-4.44-13.2-10.54-25.36-18.64-35.5a16,16,0,0,0-13.05-6V79.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 191.07,
    cy: 125.38,
    r: 24.36,
    transform: "translate(-33.7 84.06) rotate(-22.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 191.07,
    cy: 125.38,
    r: 18.28,
    transform: "translate(-33.63 83.71) rotate(-22.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.2,242.43a4.58,4.58,0,0,1-4.59-4.58V201a4.59,4.59,0,0,1,9.17,0v36.89A4.58,4.58,0,0,1,190.2,242.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M173.58,130.68a17,17,0,0,0,16.61-8.7c4.19-7.06.88-14.88.88-14.88a18.74,18.74,0,0,0-16.52,10.46A17.31,17.31,0,0,0,173.58,130.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M200.14,250.36H180.32s-8.1,11.48-1.61,29.86a32.59,32.59,0,0,0,10.2,14.45,2,2,0,0,0,2.64,0,32.59,32.59,0,0,0,10.2-14.45C208.24,261.84,200.14,250.36,200.14,250.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M182.83,250.36s-6.49,13.53.25,27.15c.67,1.36,2,1.78,3,1l2.15-1.69v7.28c0,2.68,2.29,4.17,3.78,2.43,4.82-5.64,11.84-17.72,5.71-36.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M185.42,250.36s-3.38,4.94-.5,13.79a11,11,0,0,0,2.73,4.28c.62.56,1.4-.2,1.34-1.33-.14-2.71-.05-7,1.72-8.42s3.31.52,4.32,2.15c.51.82,1.38.39,1.52-.73.32-2.53.31-6.46-1.92-9.74Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e2c3636369989abe19a6469936ebc2e9.svg";
export { ForwardRef as ReactComponent };